import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    this.sourceTarget.select();

    const result = navigator.clipboard.writeText(this.sourceTarget.value);

    result.then(() => {
      console.log("Success");
      this.showTooltip(event.target);
    }).catch((error) => {
      console.warn(error);
    });
  }

  showTooltip(element) {
    const tooltip = bootstrap.Tooltip.getOrCreateInstance(element, {
      title: "Link copiado!",
      trigger: "manual"
    })
    tooltip.show();

    clearTimeout(this.timeoutID);
    this.timeoutID = setTimeout(() => {
      tooltip.dispose();
    }, 3000);
  }
}
